export const about = {
  label: 'Company',
  title: 'Purpose & Principles',
  purpose: {
    title: 'Holding Purpose',
    content: 'Holding and managing equity investments in our own name and for our own account, not as a service for third parties, and managing proprietary assets. DR Group GmbH is an investment holding company that does not provide operational services.'
  },
  principles: {
    title: 'Principles',
    content: 'We pursue a long-term strategy in selecting and managing our investments. Our decisions are based on careful analysis and clear governance structures.'
  },
  governance: {
    title: 'Governance',
    content: 'Clear separation between holding level and operational participations. The holding assumes ownership, capital allocation and governance, while participations operate independently.'
  },
  separation: {
    title: 'Separation of Roles',
    holdco: {
      label: 'HoldCo',
      items: [
        'Ownership',
        'Capital allocation',
        'Governance'
      ]
    },
    participations: {
      label: 'Participations',
      items: [
        'Operations',
        'Contracting',
        'Delivery'
      ]
    }
  }
};